import styled from "styled-components";

const HeaderWrapper = styled.div`
  position: relative;
  top: 0;
  left: 0;
  padding: 12px 16px;
  text-align: center;
  border-bottom: 1px solid #f1f3f5;

  img {
    max-width: 24px;
    position: absolute;
    left: 16px;
    cursor: pointer;
  }
`;

const HeaderTitle = styled.h2`
  font-size: 1.125rem;
  font-weight: bold;
`;

export { HeaderTitle, HeaderWrapper };
